import qs from 'qs';
import instance from 'api';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IPosition, IRealEstate, IUser, IUserKPI } from './interfaces';

export const getUserKPIList = (data: IDynamicTableParams) => {
  return instance()
    .post<IUserKPI[]>('/kpi/user/list', data)
    .then((response) => response.data);
};

export const getUserKPIAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/kpi/user/availableColumns')
    .then((response) => response.data);
};

export const getUserKPIAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/kpi/user/availableGroupColumns')
    .then((response) => response.data);
};

export const loadUserKPI = (kpiUserId: number) => {
  return instance()
    .post<IUserKPI>('/kpi/user/load/', { kpiUserId })
    .then((response) => response.data);
};

export const createUserKPI = (userKPI: IUserKPI) => {
  return instance()
    .post<IUserKPI>('/kpi/user/save', userKPI)
    .then((response) => response.data);
};

export const updateUserKPI = (userKPI: IUserKPI) => {
  return instance()
    .post<IUserKPI>('/kpi/user/update', userKPI)
    .then((response) => response.data);
};

export const findRepeatsUser = (params: Partial<IUserKPI>) => {
  return instance()
    .get<void>('/kpi/user/findRepeats', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};

// dictionaries
export const getRealEstates = (
  data: {
    includeUnserved: boolean;
    onlyWithKeytransferDate: boolean;
    searchWithCity?: boolean;
    nameWithCity?: boolean;
  } = {
    includeUnserved: true,
    onlyWithKeytransferDate: true,
    searchWithCity: true,
    nameWithCity: true,
  },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstatesShort', data)
    .then((response) => response.data);
};

export const getPositions = (params: { realEstateGuids: string[] }) => {
  return instance()
    .get<IPosition[]>('/kpi/user/listPosition', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};

export const getUsers = (params: { positionId: number; realEstateGuids: string[] }) => {
  return instance()
    .get<IUser[]>('/kpi/user/listUser', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};
